/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetConfigUpdate } from "./SheetConfigUpdate";
import { SheetUpdate } from "./SheetUpdate";
export const SheetConfigOrUpdate = core.serialization.object({}).extend(SheetConfigUpdate).extend(SheetUpdate);
